import numeral from 'numeral';

const MetricLine = ({ label, value }) => (
    <div className="widget-content-column-line">
        <span>{label}</span>
        <strong>{value}</strong>
    </div>
);

const Metrics = (data) => {
    return (
        <div className="widget">
            <h4 className="widget-header">Metrics</h4>
            <div className="widget-content">
                <div className="widget-content-column">
                    <div className="widget-content-column-section">
                        <h5 className="widget-header-title">
                            {' '}
                            Management (10yr)
                        </h5>
                        <MetricLine
                            label="ROE"
                            value={numeral(data.data.AVGROE).format('%')}
                        />
                        <MetricLine
                            label="ROA"
                            value={numeral(data.data.AVGROA).format('%')}
                        />
                    </div>
                    <div className="widget-content-column-section">
                        <h5 className="widget-header-title">Price</h5>
                        <MetricLine
                            label="Price"
                            value={numeral(data.data.Price).format('$0.00a')}
                        />
                        <MetricLine
                            label="P/E"
                            value={numeral(data.data.PE).format('#')}
                        />
                        <MetricLine
                            label="P/R"
                            value={numeral(data.data.PR).format('#')}
                        />
                        {/* <div className="widget-content-column-line">
                            <li>P/FCF</li>
                            <li>xx</li>
                        </div> */}
                        <MetricLine
                            label="P/BV"
                            value={numeral(data.data.PBV).format('#')}
                        />
                        {/* <div className="widget-content-column-line">
                            <li>EV/EBITDA</li>
                            <li>xx</li>
                        </div> */}
                    </div>
                </div>
                <div className="widget-content-column">
                    <div className="widget-content-column-section">
                        <h5 className="widget-header-title">
                            Competitive Advantage (10yr)
                        </h5>
                        <MetricLine
                            label="EPS Growth"
                            value={numeral(data.data.EPSGrowth).format('%')}
                        />
                        <MetricLine
                            label="SPS Growth"
                            value={numeral(data.data.SPSGrowth).format('%')}
                        />
                        {/* <div className="widget-content-column-line">
                            <li>FCF Growth</li>
                            <li>xx</li>
                        </div> */}
                        <MetricLine
                            label="BVPS Growth"
                            value={numeral(data.data.BVPSGrowth).format('%')}
                        />
                        <MetricLine
                            label="Avg Profit Margin"
                            value={numeral(data.data.PROFMargin).format('%')}
                        />
                    </div>
                    <div className="widget-content-column-section">
                        <h5 className="widget-header-title">Risk</h5>
                        {/* <div className="widget-content-column-line">
                            <li>Credit Rating</li>
                            <li>xx</li>
                        </div>
                        <div className="widget-content-column-line">
                            <li>Bond Yield</li>
                            <li>xx</li>
                        </div> */}
                        <MetricLine
                            label="Debt/Earnings"
                            value={numeral(data.data.DPE).format('#')}
                        />
                        <MetricLine
                            label="Debt/Equity"
                            value={numeral(data.data.DPBV).format('#')}
                        />
                        {/* <div className="widget-content-column-line">
                            <li>Interest/FCF</li>
                            <li>xx</li>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Metrics;
